define("ember-svg-jar/inlined/skittle-laterpay", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<g clip-path=\"url(#clip0_5025_49058)\"><path d=\"M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14z\" fill=\"#000\"/><path d=\"M5.992 16.282V5.135h5.054l11.732 12.892v4.338H11.314l-5.322-6.082z\" fill=\"#F8F2EA\"/><path d=\"M16.77 12.592v3.122H6.6V5.782h3.838v6.81h6.333z\" fill=\"#000\"/></g><defs><clipPath id=\"clip0_5025_49058\"><path fill=\"#fff\" d=\"M0 0h28v28H0z\"/></clipPath></defs>",
    "attrs": {
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  };
});